module.exports = "<div class=\"footer\">\n  <span> IoT Foundation - <a [href]=\"url\">OST</a> </span>\n</div>\n"